module.exports = __webpack_public_path__ + "img/1920_header_logo.4bed0e69.svg";